import { render, staticRenderFns } from "./realTimeAccount.vue?vue&type=template&id=5fb5a098&scoped=true&"
import script from "./realTimeAccount.vue?vue&type=script&lang=js&"
export * from "./realTimeAccount.vue?vue&type=script&lang=js&"
import style0 from "./realTimeAccount.vue?vue&type=style&index=0&id=5fb5a098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb5a098",
  null
  
)

export default component.exports